module.exports = __webpack_public_path__ + "img/icon_gnb_arrow_close.1ce47a15.svg";